// extracted by mini-css-extract-plugin
module.exports = {"Categories":"Subscription__Categories_1X3jR","SendPolicy":"Subscription__SendPolicy_H-2Gh"};